export const getUser = ({ user: { username } }) => username
